<script lang="ts">
  import { theme } from '../lib/theme.svelte';
</script>

<button type="button" class="theme-toggle" onclick={() => theme.toggle()} aria-label="Cambiar tema">
  {theme.value === 'dark' ? '☀️' : '🌙'}
</button>

<style>
  .theme-toggle {
    border: 1px solid var(--border);
    background: var(--bg-surface);
    border-radius: 8px;
    padding: 0.35rem 0.55rem;
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;
  }
  .theme-toggle:hover { background: var(--brand-soft); border-color: var(--brand); }
</style>
